<template>
  <div class="order">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
        </div>
      </div>
      <div class="card mb-3 table-top-bar">
        <div class="card-body p-0">
          <div class="input-group">
            <span class="input-group-text d-none d-sm-block">
              顯示第
              {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
              {{
                currentPage == 1
                  ? totalRows > perPage
                    ? perPage
                    : totalRows
                  : perPage * (currentPage - 1) + perPage > totalRows
                  ? totalRows
                  : perPage * (currentPage - 1) + perPage
              }}
              項結果，共 {{ totalRows }} 項
            </span>
            <input
              v-model="filter"
              type="text"
              class="form-control"
              placeholder="搜尋"
            />
            <span class="input-group-text"><i class="bi bi-search"></i></span>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <b-table
            :responsive="windowWidth > breakpoints.sm"
            :stacked="windowWidth <= breakpoints.sm"
            borderless
            no-provider-filtering
            head-variant="light"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                {{ scope.label }}
              </div>
            </template>
            <template v-slot:cell(price)="data">
              {{ internationalNumberFormat(data.item.price) }}
            </template>
            <template v-slot:cell(created_at)="data">
              {{ new Date(data.item.created_at).format('yyyy-MM-dd hh:mm') }}
            </template>
            <template v-slot:cell(active)="data">
              <router-link
                custom
                v-slot="{ navigate }"
                :to="{ name: 'OrderDetails', params: { id: data.item.id } }"
              >
                <button
                  @click="navigate"
                  type="button"
                  class="btn btn-link px-1"
                >
                  <i class="bi bi-clipboard-check"></i>
                </button>
              </router-link>
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-block d-sm-none text-center mb-3">
        顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
        {{
          currentPage == 1
            ? totalRows > perPage
              ? perPage
              : totalRows
            : perPage * (currentPage - 1) + perPage > totalRows
            ? totalRows
            : perPage * (currentPage - 1) + perPage
        }}
        項結果，共 {{ totalRows }} 項
      </div>
      <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="right"
        first-number
        last-number
        class="mb-sm-0 mb-3 mt-sm-0 mt-3"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { order } from '@/http/api/order.js'
import { mapState, mapMutations, mapGetters } from 'vuex'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

export default {
  name: 'Order',
  components: { Title, Breadcrumb },
  data () {
    return {
      currentPage: 1,
      filter: null,
      filterOn: ['serial_no', 'orderer_name', 'orderer_phone', 'orderer_email'],
      fields: [
        {
          key: 'serial_no',
          label: '訂單編號',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'orderer_name',
          label: '姓名',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'orderer_phone',
          label: '電話',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'orderer_email',
          label: '信箱',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'price',
          label: '總金額',
          class: 'align-middle text-end',
          sortable: true
        },
        {
          key: 'created_at',
          label: '下單時間',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'active',
          label: '詳細資料',
          class: 'align-middle text-center'
        }
      ],
      items: null
    }
  },
  computed: {
    ...mapState([
      'token',
      'windowWidth',
      'breakpoints',
      'perPage',
      'totalRows'
    ]),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.getData()
      }
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'Loading',
      'Loaded',
      'SetRouterName',
      'SetTotalRows',
      'SetErrMsg'
    ]),
    getData () {
      const vm = this
      vm.Loading()
      order
        .get('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.items = data.data.sort((a, b) =>
              Date.parse(a.created_at).valueOf() >
              Date.parse(b.created_at).valueOf()
                ? -1
                : 1
            )
            vm.SetTotalRows(vm.items.length)
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    internationalNumberFormat (number) {
      return new Intl.NumberFormat('en-IN').format(number)
    },
    onFiltered (filteredItems) {
      const vm = this
      vm.SetTotalRows(filteredItems.length)
      vm.currentPage = 1
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.getData()
    }
  }
}
</script>
